export const ACCOUNT_SUSPENDED_EVENT = 'account-suspended';

export interface AccountSuspendedDetail {
  message: string;
  reason?: string | null;
}

/**
 * The API refuses every request from a suspended account with a 403 {error: "account_suspended"}.
 * Nearly every service calls fetch directly, so rather than teach each one, wrap fetch once:
 * the first such response signs the user out and raises an event the notice dialog listens for.
 */
export const installSuspensionGuard = (onSuspended: () => void): void => {
  const originalFetch = window.fetch.bind(window);
  let announced = false;
  window.fetch = async (...args: Parameters<typeof fetch>) => {
    const res = await originalFetch(...args);
    if (res.status === 403 && !announced) {
      try {
        const body = await res.clone().json();
        if (body?.error === 'account_suspended') {
          announced = true;
          onSuspended();
          window.dispatchEvent(new CustomEvent<AccountSuspendedDetail>(ACCOUNT_SUSPENDED_EVENT, {
            detail: { message: body.message, reason: body.reason },
          }));
        }
      } catch {
        // Not JSON — an ordinary 403.
      }
    }
    return res;
  };
};
